import { useContext, useRef, useMemo } from 'react';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { parseUrl } from '../product-results-helpers';
import useAdditionalSearchParams from './useAdditionalSearchParams';

const useProductResultsParamsPLP = (props) => {
  const {
    pageType,
  } = props;

  const isSearch = pageType === 'search';
  const disableSSR = typeof window !== 'undefined' && window.DISABLE_SSR;
  const varnish = !disableSSR && !isSearch;
  const store = useStore({ varnish, online: false });
  const ctx = useContext(ExperienceContext);
  const { path, deliveryZip: serverDeliveryZip, clientStore } = ctx;
  const { isCustomerIdentified = false } = useThdCustomer() || {};

  // Constants
  // const SERVER_SIDE_PRODUCT_POD_COUNT = 12;
  // const CLIENT_SIDE_PRODUCT_POD_COUNT = 48;

  const SERVER_SIDE_PRODUCT_POD_COUNT = isSearch ? 24 : 12;
  const CLIENT_SIDE_PRODUCT_POD_COUNT = 24;

  const urlParams = useMemo(() => {
    const cleanPath = path.replace(/^\/render[^/]*/, '');
    return parseUrl({ path: cleanPath });
  }, [path]);

  const {
    catStyle,
    keyword,
    lowerbound,
    Nao = 0,
    nValue,
    sortby,
    sortorder,
    upperbound,
    skipSpellCheck
  } = urlParams;

  const searchNavPropsRef = useRef({
    askForSponsored: isSearch,
    deliveryZip: serverDeliveryZip,
    pageSize: disableSSR ? CLIENT_SIDE_PRODUCT_POD_COUNT : SERVER_SIDE_PRODUCT_POD_COUNT
  });

  const totalPageSizeRef = useRef(disableSSR ? CLIENT_SIDE_PRODUCT_POD_COUNT : SERVER_SIDE_PRODUCT_POD_COUNT);
  const hasSponsoredSorts = !sortby || ['bestmatch', 'topsellers'].indexOf(sortby) > -1;
  const showProducts = /showproducts/i.test(catStyle);

  let THDCustomer = {};
  if (clientStore) {
    let deliveryZipCode;
    if (
      typeof window !== 'undefined'
      && window?.THD_LOCALIZER_AUTO_INIT?.Localizer?.getDeliveryZipcodeDetails
    ) {
      deliveryZipCode = window?.THD_LOCALIZER_AUTO_INIT?.Localizer?.getDeliveryZipcodeDetails();
    }
    searchNavPropsRef.current = {
      pageSize: CLIENT_SIDE_PRODUCT_POD_COUNT,
      askForSponsored: true,
      deliveryZip: deliveryZipCode?.zipcode
    };
    totalPageSizeRef.current = CLIENT_SIDE_PRODUCT_POD_COUNT;

    THDCustomer = typeof window !== 'undefined' ? window.THDCustomer?.default : {};
  }

  const additionalSearchParams = useAdditionalSearchParams({
    askForSponsored: searchNavPropsRef.current?.askForSponsored,
    hasSponsoredSorts,
    deliveryZip: searchNavPropsRef.current?.deliveryZip,
    showProducts,
    skipSpellCheck
  });
  // Wrap return value in useMemo to react to context/store changes
  const productResultsParams = useMemo(() => ({
    additionalSearchParams,
    keyword,
    lowerbound,
    nValue,
    start: Nao,
    storeId: store?.storeId,
    sortby,
    sortorder,
    upperbound,
    isCustomerIdentified: store?.isLocalized ? isCustomerIdentified : false,
    pageSize: searchNavPropsRef.current?.pageSize
  }), [
    additionalSearchParams,
    keyword,
    lowerbound,
    nValue,
    Nao,
    store?.storeId,
    store?.isLocalized,
    sortby,
    sortorder,
    upperbound,
    isCustomerIdentified
  ]);

  return productResultsParams;
};

export default useProductResultsParamsPLP;